import { render, staticRenderFns } from "./sudokuInstruction.vue?vue&type=template&id=447020a6"
import script from "./sudokuInstruction.vue?vue&type=script&lang=js"
export * from "./sudokuInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports